import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createSharedComposable } from '@vueuse/core';
import { HeaderServiceProxy } from '@/services/header-service-proxy';

export const useHeaderService = createSharedComposable(() => {
    const headerServiceInstance = injectService<HeaderServiceProxy>(HeaderServiceProxy);
    const headerService = headerServiceInstance.headerService;

    return {
        headerService,
    };
});
